var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 88,
    viewBox: "0 0 63 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_2349_9072",
    maskUnits: "userSpaceOnUse",
    x: 4.44824,
    y: 0.804688,
    width: 55,
    height: 69,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4.44824,
    y: 0.804688,
    width: 55,
    height: 69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1357 63.8984C23.042 56.2812 9.44824 38.1172 9.44824 27.8047C9.44824 15.3828 19.4092 5.30469 31.9482 5.30469C44.3701 5.30469 54.4482 15.3828 54.4482 27.8047C54.4482 38.1172 40.7373 56.2812 34.6436 63.8984C33.2373 65.6562 30.542 65.6562 29.1357 63.8984ZM31.9482 35.3047C36.0498 35.3047 39.4482 32.0234 39.4482 27.8047C39.4482 23.7031 36.0498 20.3047 31.9482 20.3047C27.7295 20.3047 24.4482 23.7031 24.4482 27.8047C24.4482 32.0234 27.7295 35.3047 31.9482 35.3047Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6497 61.0873C29.6537 57.3424 24.8623 51.0625 20.8427 44.5094C18.8322 41.2317 17.0679 37.971 15.8185 34.9862C14.5393 31.9302 13.9482 29.5075 13.9482 27.8047H4.94824C4.94824 31.2581 6.0564 34.9732 7.51646 38.4613C9.00634 42.0207 11.0214 45.7107 13.171 49.2152C17.4717 56.2266 22.524 62.8373 25.6218 66.7096L32.6497 61.0873ZM13.9482 27.8047C13.9482 17.8528 21.9097 9.80469 31.9482 9.80469V0.804688C16.9086 0.804688 4.94824 12.9128 4.94824 27.8047H13.9482ZM31.9482 9.80469C41.8848 9.80469 49.9482 17.8681 49.9482 27.8047H58.9482C58.9482 12.8975 46.8554 0.804688 31.9482 0.804688V9.80469ZM49.9482 27.8047C49.9482 29.5002 49.3542 31.9181 48.0646 34.9744C46.8055 37.9585 45.0277 41.2189 43.0026 44.4974C38.9538 51.0519 34.1329 57.3332 31.1296 61.0873L38.1575 66.7096C41.248 62.8465 46.3294 56.2372 50.6595 49.2272C52.8238 45.7235 54.8546 42.0332 56.3567 38.4731C57.8284 34.9852 58.9482 31.2654 58.9482 27.8047H49.9482ZM31.1296 61.0873C31.5249 60.5933 32.2544 60.5933 32.6497 61.0873L25.6218 66.7096C28.8295 70.7192 34.9498 70.7192 38.1575 66.7096L31.1296 61.0873ZM31.9482 39.8047C38.4891 39.8047 43.9482 34.5545 43.9482 27.8047H34.9482C34.9482 29.4924 33.6105 30.8047 31.9482 30.8047V39.8047ZM43.9482 27.8047C43.9482 21.2178 38.5351 15.8047 31.9482 15.8047V24.8047C33.5645 24.8047 34.9482 26.1884 34.9482 27.8047H43.9482ZM31.9482 15.8047C25.1985 15.8047 19.9482 21.2638 19.9482 27.8047H28.9482C28.9482 26.1424 30.2605 24.8047 31.9482 24.8047V15.8047ZM19.9482 27.8047C19.9482 34.5087 25.2442 39.8047 31.9482 39.8047V30.8047C30.2148 30.8047 28.9482 29.5382 28.9482 27.8047H19.9482Z",
    fill: "#005e9d",
    mask: "url(#path-1-outside-1_2349_9072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3093 69C56.7452 69.7991 60 72.4418 60 75.4C60 81.8 41.8277 85 30.5798 85C19.332 85 3 81.8 3 75.4C3 72.4418 6.06291 69.9056 14.4847 69.1064",
    stroke: "#005e9d",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1efc0eaf39354c558d74f97f2019d1be.svg";
export { ForwardRef as ReactComponent };